module.exports = __webpack_public_path__ + "img/weissweinglasoben.5bdbf911.jpg";